/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: GPT-5 Codex
 🏢 Company: Ring2All LLC
 📄 File: constants/callTypes.ts
 🗓️ Created: 2025-01-27
 🧩 Description:
    Call Type (direction) values for CDR Filters.
────────────────────────────────────────────────────────────────*/

/**
 * List of Call Type (direction) values
 */
export const CALL_TYPE_VALUES = [
  'inbound',
  'outbound',
  'internal',
  'transit',
] as const;

export type CallTypeValue = typeof CALL_TYPE_VALUES[number];

